import { Link } from "react-router-dom";
import { ArrowRight, ChevronRight } from "lucide-react";

const SERVICES = [
  {
    title: "Virtual Staging",
    description: "Turn empty rooms into sale-ready spaces",
    badge: "Most Popular",
    image: "https://customer-assets.emergentagent.com/job_virtual-stage-uk/artifacts/fiv5p37c_Study%20-%20use%20one%20of%20these%20%281%29.jpg",
    cta: "Learn More",
    link: "/virtual-staging-uk",
    highlight: true,
  },
  {
    title: "3D Renders",
    description: "Ideal for off-plan and developments",
    image: "https://customer-assets.emergentagent.com/job_virtual-stage-uk/artifacts/mlpg0mca_stockton-roadexteriorfinal.jpg",
    cta: "Request Quote",
    link: "/3d-property-rendering-uk",
    highlight: false,
  },
];

export default function ServicesRedirectPage() {
  return (
    <main data-testid="services-redirect-page" className="pt-24">
      <section className="py-20 lg:py-28">
        <div className="max-w-5xl mx-auto px-8 lg:px-16">
          <div className="text-center mb-14 lg:mb-18">
            <p className="uppercase text-[11px] tracking-[0.3em] text-[#758C7B] mb-4 font-medium">
              What We Offer
            </p>
            <h1 className="font-['Outfit'] text-2xl sm:text-3xl lg:text-[2.5rem] tracking-[-0.01em] text-[#0D2D54] font-extralight mb-4">
              Our Services
            </h1>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-3xl mx-auto">
            {SERVICES.map((service, i) => (
              <div
                key={i}
                data-testid={`redirect-service-${i}`}
                className={`bg-white border ${
                  service.highlight ? "border-[#0D2D54]" : "border-[#E8E8E4]"
                } overflow-hidden group hover:-translate-y-1 hover:shadow-xl transition-all duration-300`}
              >
                <div className="relative overflow-hidden h-56">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                    loading="lazy"
                  />
                  {service.badge && (
                    <span className="absolute top-4 left-4 bg-[#758C7B] text-white text-[10px] uppercase tracking-[0.15em] px-3 py-1.5 font-medium">
                      {service.badge}
                    </span>
                  )}
                </div>
                <div className="p-8">
                  <h2 className="font-['Outfit'] text-xl font-medium text-[#0D2D54] mb-2">
                    {service.title}
                  </h2>
                  <p className="text-sm text-[#6B7280] mb-6">{service.description}</p>
                  <Link
                    to={service.link}
                    className={`inline-flex items-center gap-2 text-sm font-medium tracking-wide transition-colors ${
                      service.highlight
                        ? "bg-[#0D2D54] text-white px-6 py-3 hover:bg-[#1A3D6B]"
                        : "text-[#0D2D54] hover:text-[#1A3D6B]"
                    }`}
                  >
                    {service.cta}
                    <ChevronRight size={14} />
                  </Link>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-14">
            <p className="text-sm text-[#6B7280] mb-4">
              Not sure what you need? Get in touch and we'll help.
            </p>
            <a
              href="mailto:rachel@thesecretseller.co.uk"
              className="text-sm font-medium text-[#0D2D54] hover:underline"
            >
              rachel@thesecretseller.co.uk
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}
